import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import React, { useEffect, useState } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import Header from '../../Includes/Header';
import BackButton from '../../Includes/BackButton';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { ToastBox, notifyError } from 'MyComponents/Toaster';
import axios, { AxiosError } from 'axios';
import config from '../../../config';
import { setwizardPageNumber, setUserID } from '../../authslice';
import { getUserID } from 'Utils/user';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';
import { useTranslation } from 'react-i18next';

interface Props { }

const Questionnaire_Screen7: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
    const email = useSelector((state: RootState) => state.auth.email);
    const userID = useSelector((state: RootState) => state.auth.userID);

    const questionnaireScreen1 = useSelector((state: RootState) => state.auth.questionnaireScreen1);
    const armUpUsePurpose = questionnaireScreen1.join(', ');
    const questionnaireScreen2 = useSelector((state: RootState) => state.auth.questionnaireScreen2);
    const sourceOfFund = questionnaireScreen2.join(', ');
    const selectedIndustry = useSelector((state: RootState) => state.auth.questionnaireScreen3);
    const employmentStatus = useSelector((state: RootState) => state.auth.questionnaireScreen4);
    const accountActivityInfo = useSelector((state: RootState) => state.auth.questionnaireScreen5);
    const questionnaireScreen6 = useSelector((state: RootState) => state.auth.questionnaireScreen6);
    const pepRelation = questionnaireScreen6.join(', ');

    const [isChecked, setIsChecked] = useState(false);
    const [validated, setValidated] = useState(false);

    const saveQuestionnaireData_baseURL = `${config.NODE_API_BASE_URL}/wso2/saveQuestionnaireData`;

    const saveQuestionnaireData = async (
        email: string, userId: string, purpose: string, primarySource: string,
        selectedIndustry: string, employmentStatus: string,
        accountActivity: string, isPep: string, pepRelation: string
    ) => {
        try {
            const response = await axios.post(saveQuestionnaireData_baseURL, {
                email, userId, purpose, primarySource, selectedIndustry, employmentStatus, accountActivity, isPep, pepRelation
            });
            return response?.data;
        } catch (error) {
            const axiosError = error as AxiosError;
            if (axiosError.response?.status === 404) {
                notifyError('Uploading Failed');
            } else {
                notifyError('Something Went Wrong');
            }
            console.error('Error saving questionnaire data:', axiosError);
        }
    };

    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };

    const submitForm = async () => {
        setValidated(true);
        if (!isChecked) return;

        const isPep = pepRelation ? "1" : "0";
        const pepData = pepRelation || "none";

        let currentUserID = userID;

        if (!currentUserID && email) {
            const resolvedID = await getUserID(email);
            if (resolvedID && resolvedID !== 0) {
                currentUserID = resolvedID;
                dispatch(setUserID(resolvedID));
            }
        }

        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);

        if (currentUserID) {
            updatePersonalKycDraftStep(currentUserID, 'questionnaire', { screen7: 'acknowledged' });
            updatePersonalKycDraftStep(currentUserID, 'wizardState', { pageNumber: page + 1 });
        }
    };

    return (
        <>
            <ToastBox />
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-flex align-items-start py-3">
                                        <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                                        <div>
                                            <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                                            <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="px-2 px-md-5">
                                <Col md={12}>
                                    <div className="d-none d-md-flex align-items-center">
                                        <ProgressBar variant="primary" className="custom_progressbar mr-2" now={100} />
                                        <p className="fw-bold small py-3 px-3 m-0">7/7</p>
                                    </div>
                                    <p className="fw-bold text-start mt-4 m-0">{t('kyc.q7_title')}</p>

                                    <Form noValidate onSubmit={handleSubmit(submitForm)}>
                                        <Row className="mt-2 text-start">
                                            <Form.Group as={Row} className="mb-1" controlId="formHorizontalCheck">
                                                <Col>
                                                    <Form.Check
                                                        required
                                                        checked={isChecked}
                                                        onChange={handleCheckboxChange}
                                                        className="text-secondary"
                                                        label={t('kyc.ownership_ack')}
                                                        isInvalid={validated && !isChecked}
                                                        feedback={t('kyc.please_ack')}
                                                        feedbackType="invalid"
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mt-4 text-start">
                                            <Col md={8}>
                                                <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                                                    {t('common.next')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(Questionnaire_Screen7);

export default connect(null)(form);
